<template>
    <div class="" >
        <v-expansion-panels style="border-radius:0;" v-model="panel">
            <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
                <div class="top-navigation-secondary-image">
                    <a target="_blank" href="https://www.emerson.com/en-us">
                        <img src='../assets/images/emerson-logo.png' alt="emerson_logo" width="56px" />
                    </a>
                </div>
                <v-icon v-if="panel != 0"  style="justify-content:end">mdi-menu</v-icon>
                <v-icon v-if="panel == 0"  style="justify-content:end">mdi-close</v-icon>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <div style="display:flex;">
                    <div class="top-navigation-secondary-group">
                        <div class="top-navigation-secondary-group-item">
                            <span class="cursor-pointer hover:text-navy-blue">
                                <a
                                    target="_blank"
                                    href="https://www.emerson.com/en-us/automation-solutions"
                                >
                                    AUTOMATION SOLUTIONS
                                </a>
                            </span>
                        </div>
                        <div class="top-navigation-secondary-group-item">
                            <span class="cursor-pointer hover:text-navy-blue">
                                <a
                                    target="_blank"
                                    href="https://www.emerson.com/en-us/commercial-residential-solutions"
                                >
                                    COMMERCIAL & <br> RESIDENTIAL SOLUTIONS
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="top-navigation-container">
				<div class="text-white">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title> 
                                        <a target="_blank" href="https://www.emerson.com/en-us/about-us">
                                            About Us
                                        </a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title> 
                                        <a target="_blank" href="https://www.emerson.com/en-us/investors">
                                            Investors
                                        </a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title> 
                                        <a target="_blank" href="https://www.emerson.com/en-us/careers/diversity-and-inclusion">
                                            Diversity
                                        </a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title> 
                                        <a target="_blank" href="https://www.emerson.com/en-us/careers">
                                            Careers
                                        </a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title> 
                                        <a target="_blank" href="https://www.emerson.com/en-us/esg/sustainability">
                                            Sustainability
                                        </a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title> 
                                        <a target="_blank" href="https://www.emerson.com/en-us/contact-us">
                                            Contact Us
                                        </a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title> 
                                        <a target="_blank" href="https://www.emerson.com/en-us/news">
                                            Newsroom
                                        </a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
				</div>
			</div>
            </v-expansion-panel-content>    
        </v-expansion-panel>
    </v-expansion-panels>
    </div>
</template>

<script>
export default {
name:"MobileEmersonHeader",
data: () => ({
      drawer: false,
      group: null,
      panel:-1,
    }),
}
</script>
<style scoped>
@font-face {
font-family: 'Noto Sans';
src: url('../fonts/Noto_Sans/NotoSans-Light.ttf') format("truetype");
}
.top-navigation-container{
background-color: black;
font-family: 'Noto Sans'!important ;
font-weight: 500;
padding-top: 5px;
padding-bottom: 5px;
font-size: .375rem;
text-align: right;
justify-content: start;
}
.top-navigation-container a{
color: white;
text-decoration: none;
}

.top-navigation-secondary-container{
display: flex;
height: 55px;
box-shadow: 0 3px 3px rgba(0,0,0,0.2);
justify-content: center;
}
.top-navigation-secondary-image{
margin-right: 4%;
}
.top-navigation-secondary-group{
display: grid;
grid-template-columns: auto auto;
width: 100%;
}
.top-navigation-secondary-group-item{
text-align: center;
padding: 10px;
justify-content: center;
font-family: 'Noto Sans'!important ;
font-weight: 600;
font-size: .575rem;
letter-spacing:.08em;
}
.top-navigation-secondary-group-item a{
text-decoration: none;
color: #2d383f;
}
a:active, a:hover{
color: #00573d!important;
}
.v-list-item{
    text-align: left;
}
.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
.v-list-item__title{
    font-size:.575rem!important;
}
</style>